import { Pipe, PipeTransform } from "@angular/core";
import { SELECTED_CURRENCY } from "@models/trade-offer.model";
import { getAvailableToStake } from "../../components/amount-selector/+state/utils/staking-amount-selector.util";
import { StakingAmountUIModel } from "../entities/staking-amount-selector-state.model";

@Pipe({
	name: "staking_amount_selector_state_type",
	standalone: false
})
export class StakingAmountSelectorStateTypePipe implements PipeTransform {
	transform(state: StakingAmountUIModel): SELECTED_CURRENCY {
		return state.displayTradable ? SELECTED_CURRENCY.CRYPTOCOIN : SELECTED_CURRENCY.FIAT;
	}
}

@Pipe({
	name: "staking_amount_selector_available_to_stake",
	standalone: false
})
export class StakingAmountSelectorAvailableToStakePipe implements PipeTransform {
	transform(UIModel: StakingAmountUIModel): number {
		return getAvailableToStake(UIModel);
	}
}
